export class ApiConstants {
  static readonly BASEURL = '/vi-api/dataservice/v1/';
  static readonly FILEAPIBASEURL = '/fileapi/v1/FileManagement/';
  static readonly DASHBOARD = 'Dashboard/';
  static readonly CAMERAPROFILE = 'CameraProfile/';
  static readonly MEDIADATA = 'MediaData/';
  static readonly EVENT = 'Event/';
  static readonly ZONECONFIGURATION = 'ZoneConfiguration/';
  static readonly ZONECONFIGHISHTORY = 'ZoneConfigHistory/';
  static readonly GETEQUIPMENTMEDIA = 'get-equipment-media/';
  static readonly ZONESETTING = 'ZoneSetting';
  static readonly GATEWAY = 'Gateway/';
  static readonly CAMERA = 'Camera/';
  static readonly USERSETTING = 'UserSettings/';
  static readonly NOTIFICATION = 'Notification/';
  static readonly EMAILNOTIFICATION = 'MediaData/';
  static readonly EQUIPMENT = 'Equipment';
}
